var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3143_9583",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 63,
    height: 63
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 63,
    fill: "url(#pattern0_3143_9583)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3143_9583)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.4766,
    cy: 57.5859,
    rx: 86.1328,
    ry: 94.5,
    fill: "#4941A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3143_9583",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3143_9583",
    transform: "scale(0.0078125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3143_9583",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.337a6d68200cf2c476d89e239cf1d541.svg";
export { ForwardRef as ReactComponent };